<template>
  <div>
    <secondHeader />
    <div class="main">
      <sidebar />
      <div class="content">
        <div class="containar">
          <div class="content-title">
            <h2>
              ハートコメント
            </h2>
            <p>色をカスタマイズできます。</p>
            <p>作成したコードをOBSのカスタムCSSに追記してください。</p>
          </div>
          <div class="contents-block">
            <div class="heart_line__left">
                <span class="heart_line__name" :style="{ 'color': mainColor, 'border-color': mainColor, 'background-color': nameBgColor }">視聴者さん</span>
                <div class="heart_line__left-text">
                    <span class="heart_icon" :style="{ 'background-image': svgBackground2, 'background-repeat': 'no-repeat', 'background-size': 'contain', 'background-position': 'center' }"></span>
                    <div class="heart_text" :style="{ 'background-color': backgroundColor, 'border-color': mainColor, 'color': mainColor,'background-image': svgBackground, 'background-repeat': 'no-repeat', 'background-size': '40px 30px', 'background-position': 'calc(100% - 5px) calc(100% + 10px)'  }">Hello🐟</div>
                </div>
                <span class="heart_line__name" :style="{ 'color': mainColor, 'border-color': mainColor, 'background-color': nameBgColor }">視聴者さん</span>
                <div class="heart_line__left-text">
                    <span class="heart_icon" :style="{ 'background-image': svgBackground2, 'background-repeat': 'no-repeat', 'background-size': 'contain', 'background-position': 'center'}"></span>
                    <span class="heart_text" :style="{ 'background-color': backgroundColor, 'border-color': mainColor, 'color': mainColor, 'background-image': svgBackground, 'background-repeat': 'no-repeat', 'background-size': '40px 30px', 'background-position': 'calc(100% - 5px) calc(100% + 10px)' }">いい天気ですね</span>
                </div>
            </div>
            <div class="set">
              <h3>カラー選択</h3>
              <div class="color-picker-grid">
                <div class="color-picker-column">
                  <h4>背景カラー</h4>
                  <div class="color-picker-wrapper">
                    <chrome-picker :value="backgroundColorObj" @input="updateBackgroundColor"></chrome-picker>
                  </div>
                </div>
                <div class="color-picker-column">
                  <h4>メインカラー</h4>
                  <div class="color-picker-wrapper">
                    <chrome-picker :value="mainColorObj" @input="updateMainColor"></chrome-picker>
                  </div>
                </div>
                <div class="color-picker-column">
                  <h4>名前背景カラー</h4>
                  <div class="color-picker-wrapper">
                    <chrome-picker :value="nameBgColorObj" @input="updateNameBgColor"></chrome-picker>
                  </div>
                </div>
              </div>
              
              <h3>コピペ用CSS</h3>
              <div class="url-description">
                <p>LIVEコメント欄をポップアップ表示→URLをコピー→OBSでブラウザソースを追加し、URLを貼り付け→下記CSSをカスタムCSS欄にコピペ</p>
              </div>
              <h4>YouTubeLIVEコメント欄のカスタムCSS</h4>
              <div class="url-container">
                <textarea id="target" readonly class="url-input textarea" v-model="YTgeneratedCSS" />
                <button @click="copy" class="url-copy-btn">
                  <span>コピー</span>
                </button>
              </div>
              <h4>Twitchコメント欄のカスタムCSS</h4>
              <div class="url-container">
                <textarea id="target" readonly class="url-input textarea" v-model="TWgeneratedCSS" />
                <button @click="copy2" class="url-copy-btn">
                  <span>コピー</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import secondHeader from "../../components/secondHeader.vue";
import sidebar from "../../components/sidebar.vue"
import {Chrome} from 'vue-color'
export default {
    components: {
        secondHeader,
        sidebar,
        'chrome-picker': Chrome,
    },
  data() {
    return {
      backgroundColor: '#fcbcac',
      mainColor: '#A73121',
      nameBgColor: '#FFF3E2',
      backgroundColorObj: {
        hex: '#fcbcac',
        hsl: { h: 11, s: 88, l: 84, a: 1 },
        rgba: { r: 252, g: 188, b: 172, a: 1 },
        a: 1
      },
      mainColorObj: {
        hex: '#A73121',
        hsl: { h: 11, s: 70, l: 39, a: 1 },
        rgba: { r: 167, g: 49, b: 33, a: 1 },
        a: 1
      },
      nameBgColorObj: {
        hex: '#FFF3E2',
        hsl: { h: 35, s: 100, l: 94, a: 1 },
        rgba: { r: 255, g: 243, b: 226, a: 1 },
        a: 1
      },
      YTgeneratedCSS: '',
      TWgeneratedCSS: '',
    };
  },
  computed: {
    svgBackground() {
      const svgPath = `<svg xmlns='http://www.w3.org/2000/svg' version='1.1' viewBox='0.00 0.00 250.00 226.00'><path fill='${this.mainColor}' opacity='0.2' d=' M 58.61 0.00 L 69.79 0.00 C 93.04 3.19 111.95 18.02 124.55 37.23 A 0.51 0.50 45.1 0 0 125.40 37.24 C 138.08 18.16 157.05 2.95 180.36 0.00 L 191.56 0.00 C 225.65 4.65 247.28 34.18 250.00 67.21 L 250.00 82.78 C 244.58 152.40 186.69 200.83 126.78 226.00 L 123.16 226.00 C 85.67 210.27 50.29 185.91 26.13 152.91 Q 3.12 121.48 0.00 82.66 L 0.00 67.14 C 2.77 34.25 24.53 4.29 58.61 0.00 Z'></path></svg>`;
      return `url("data:image/svg+xml,${encodeURIComponent(svgPath)}")`;
    },
    svgBackground2() {
      const svgPath2 = `<svg xmlns='http://www.w3.org/2000/svg' version='1.1' viewBox='0.00 0.00 250.00 226.00'><path fill='${this.mainColor}' d=' M 58.61 0.00 L 69.79 0.00 C 93.04 3.19 111.95 18.02 124.55 37.23 A 0.51 0.50 45.1 0 0 125.40 37.24 C 138.08 18.16 157.05 2.95 180.36 0.00 L 191.56 0.00 C 225.65 4.65 247.28 34.18 250.00 67.21 L 250.00 82.78 C 244.58 152.40 186.69 200.83 126.78 226.00 L 123.16 226.00 C 85.67 210.27 50.29 185.91 26.13 152.91 Q 3.12 121.48 0.00 82.66 L 0.00 67.14 C 2.77 34.25 24.53 4.29 58.61 0.00 Z'></path></svg>`;
      return `url("data:image/svg+xml,${encodeURIComponent(svgPath2)}")`;
    },
  },
  mounted() {
    this.generateCSS();
  },
  methods: {
    generateCSS() {
      const svgPath = `<svg xmlns='http://www.w3.org/2000/svg' version='1.1' viewBox='0.00 0.00 250.00 226.00'><path fill='${this.mainColor}' opacity='0.2' d=' M 58.61 0.00 L 69.79 0.00 C 93.04 3.19 111.95 18.02 124.55 37.23 A 0.51 0.50 45.1 0 0 125.40 37.24 C 138.08 18.16 157.05 2.95 180.36 0.00 L 191.56 0.00 C 225.65 4.65 247.28 34.18 250.00 67.21 L 250.00 82.78 C 244.58 152.40 186.69 200.83 126.78 226.00 L 123.16 226.00 C 85.67 210.27 50.29 185.91 26.13 152.91 Q 3.12 121.48 0.00 82.66 L 0.00 67.14 C 2.77 34.25 24.53 4.29 58.61 0.00 Z'></path></svg>`;
      const svgPath2 = `<svg xmlns='http://www.w3.org/2000/svg' version='1.1' viewBox='0.00 0.00 250.00 226.00'><path fill='${this.mainColor}' d=' M 58.61 0.00 L 69.79 0.00 C 93.04 3.19 111.95 18.02 124.55 37.23 A 0.51 0.50 45.1 0 0 125.40 37.24 C 138.08 18.16 157.05 2.95 180.36 0.00 L 191.56 0.00 C 225.65 4.65 247.28 34.18 250.00 67.21 L 250.00 82.78 C 244.58 152.40 186.69 200.83 126.78 226.00 L 123.16 226.00 C 85.67 210.27 50.29 185.91 26.13 152.91 Q 3.12 121.48 0.00 82.66 L 0.00 67.14 C 2.77 34.25 24.53 4.29 58.61 0.00 Z'></path></svg>`;
      const svgEncoded1 = encodeURIComponent(svgPath);
      const svgEncoded2 = encodeURIComponent(svgPath2);
      this.YTgeneratedCSS = `yt-live-chat-author-chip #author-name{
        color: ${this.mainColor}!important;
        background-color: ${this.nameBgColor}!important;
    }
    yt-live-chat-text-message-renderer #message {
        background-color: ${this.backgroundColor};
        border: 2px solid ${this.mainColor} !important;
        color: ${this.mainColor} !important;
        background-image: url("data:image/svg+xml,${svgEncoded1}");
    }
    yt-live-chat-text-message-renderer #message::before{
        background-image: url("data:image/svg+xml,${svgEncoded2}");
    }
      `;
    this.TWgeneratedCSS = `.chat-author__display-name{
    color: ${this.mainColor}!important;
    background-color: ${this.nameBgColor}!important;
    }
    [data-a-target="chat-line-message-body"]{
    background-color: ${this.backgroundColor};
    border: 2px solid ${this.mainColor} !important;
    color: ${this.mainColor} !important;
    background-image: url("data:image/svg+xml,${svgEncoded1}");
    }
    [data-a-target="chat-line-message-body"]::before{
    background-image: url("data:image/svg+xml,${svgEncoded2}");
    }`;
    },
    async copy() {
      await navigator.clipboard.writeText(this.YTgeneratedCSS);
    },
    async copy2() {
      await navigator.clipboard.writeText(this.TWgeneratedCSS);
    },
    updateBackgroundColor(color) {
      this.backgroundColorObj = color;
      this.backgroundColor = color.hex;
    },
    updateMainColor(color) {
      this.mainColorObj = color;
      this.mainColor = color.hex;
    },
    updateNameBgColor(color) {
      this.nameBgColorObj = color;
      this.nameBgColor = color.hex;
    },
  },
  watch: {
    backgroundColor() {
      this.generateCSS();
    },
    mainColor() {
      this.generateCSS();
    },
    nameBgColor() {
      this.generateCSS();
    },
  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Kiwi+Maru&family=Single+Day&display=swap');

p {
  margin: 0;
  padding: 0;
  font-size: 14px;
}

.containar{
  margin: 0 auto;
  width:100%;
  max-width: 1200px;
}


.content-title{
  text-align: center;
  padding-bottom: 12px;
  margin-top:48px;
  margin-bottom: 48px;
}

h2{
  position: relative;
  display: inline-block;
  text-align: center;
  letter-spacing: 3px;
  text-shadow: 2px 2px 6px rgb(210 210 210 / 80%);
}

h3{
  font-size: 14px;
  margin-top: 24px;
}

h4{
  font-size: 12px;
  margin-top: 24px;
  margin-bottom: 0;
}

.main {
  min-height: 100vh;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  margin: 0 auto;
}

.content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-width: 0; /* Changed from width: 100% */
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  padding: 60px 24px; /* Adjusted padding */
}

.set{
  flex: none;
  width: 100%;
  max-width: 740px;
  padding: 24px;
  background-color: #ffffff;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  margin-left: 12px;
}

/* Color Picker Grid Layout */
.color-picker-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(225px, 1fr));
  gap: 20px;
  margin-top: 12px;
  justify-content: center;
}

.color-picker-column {
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.color-picker-column h4 {
  font-size: 12px;
  margin: 0 0 12px 0;
  color: #4a5568;
  font-weight: 600;
  text-align: center;
  width: 100%;
}

.color-picker-wrapper {
  width: 225px; /* Fixed width */
  overflow: hidden;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

  /* コメントプレビュー */
  .heart_line__left {
    flex: none;
    width: 420px;
    min-width: 320px;
    padding: 24px;
    background: #ffffff;
    border-radius: 16px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  }

    .heart_line__left-text{
        position: relative;
        width: fit-content;
        min-width: 180px!important;
        max-width: 420px!important;
        padding: 2px!important;
        transform-origin: 0% 0%;
        animation: slideIn 0.5s forwards ease-out;
        margin-top:12px;

        font-family: "Kiwi Maru", serif;
        line-height: 1.8;
        letter-spacing: 0.12em;
    }

    .heart_text {
        position: relative;
        font-weight: bold;
        border-width: 2px;
        border-style: solid;
        border-radius: 10px;
        padding: 12px 24px 12px 24px;
        margin:-5px;
        margin-bottom:0;
        display: block;
        line-height: 1!important;
    }

    .heart_icon {
        position: absolute;
        z-index:2;
        left: 6px;
        top: 40%;
        width: 0.5em;
        height: 0.5em;
    }

  .heart_line__name{
       position: relative;
       z-index: 2;
       top:12px;
        font-size: 10px !important;
        font-weight: bold;
        padding: 0px 8px 0 8px;
        border: 0.3em solid;
        border-radius: 100vh!important;
  }

/* Layout Styles */
.contents-block{
  display: -webkit-flex;
	display: flex;
	-webkit-flex-wrap: nowrap;
	flex-wrap: nowrap;
	-webkit-justify-content: space-around;
	justify-content: space-around;
	-webkit-align-items: flex-start;
	align-items: flex-start;
  margin: 24px auto;
  min-width: 0;
}

/* タブレット対応 */
@media screen and (max-width: 1324px) {
  .contents-block {
    flex-direction: column;
    align-items: center;
    gap: 32px;
  }
  
  .heart_line__left {
    width: 100%;
    max-width: 500px;
    margin: 0;
  }
  
  .set {
    width: 100%;
    max-width: 740px;
    margin: 0;
  }
}

/* サイドバーを考慮した中サイズスクリーン対応 */
@media screen and (max-width: 1048px) {
  .content {
    padding: 40px 16px;
  }

}

/* モバイル対応 */
@media screen and (max-width: 767px) {
  .content {
    padding: 24px 16px;
  }
  
  .content-title {
    margin-top: 24px;
    margin-bottom: 32px;
    padding-bottom: 8px;
  }
  
  .content-title h2 {
    font-size: 1.5rem;
    letter-spacing: 1px;
  }
  
  .content-title p {
    font-size: 13px;
    margin: 8px 0 4px 0;
  }
  
  .contents-block {
    display: block;
    margin: 0 auto;
  }

  .heart_line__left {
    width: 100%;
    max-width: none;
    min-width: 280px;
    margin: 0 0 24px 0;
    padding: 16px;
  }
  
  .set {
    width: 100%;
    max-width: none;
    margin: 0;
    padding: 16px;
  }
  
  .url-input.textarea {
    height: 60px;
  }
  
}

/* 小さなモバイル対応 */
@media screen and (max-width: 480px) {
  .content {
    padding: 16px;
  }
  
  .main {
    flex-direction: column;
  }
  
  .content-title h2 {
    font-size: 1.25rem;
  }
  
  .heart_line__left {
    min-width: 260px;
    padding: 12px;
  }
  
  .set {
    padding: 12px;
  }
  
  .url-container {
    flex-direction: column;
    gap: 12px;
  }
  
  .url-copy-btn {
    width: 100%;
    height: 40px;
  }
}

/* URL Section */
.url-description {
  margin: 12px 0 16px 0;
}

.url-description p {
  font-size: 13px;
  color: #718096;
  margin: 0 0 6px 0;
  line-height: 1.5;
}

.url-container {
  display: flex;
  gap: 8px;
  align-items: stretch;
  margin-bottom: 16px;
}

.url-input {
  flex: 1;
  height: 2.4em;
  padding: 0 12px;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
  font-size: 12px;
  background: #f8fafc;
  color: #4a5568;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  line-height: 1.4;
  resize: vertical;
}

.url-input.textarea {
  height: 76px;
  width: 100%;
  padding: 12px;
  resize: vertical;
}

.url-input:focus {
  outline: none;
  box-shadow: 0 0 0 2px #0f172a;
}

.url-copy-btn {
  padding: 0 20px;
  height: 2.4em;
  background: #0f172a;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
}

.url-copy-btn:hover {
  background: #0f172a;
  transform: translateY(-1px);
}

.url-copy-btn:active {
  transform: translateY(0);
}


</style>